import { useDetectGPU, useScroll } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useEffect, useMemo, useRef } from "react";
import { animated, useSpring } from "@react-spring/three";
import { easeInBack, easeOutBack, easeOutCirc } from "./Utils";
import ChaosMaterial from "./ChaosMaterial";
import { useControls } from "leva";

const Sphere = (props) => {
  const ref = useRef();
  const GPU = useDetectGPU();
  const scroll = useScroll();

  const resolution = useMemo(() => {
    switch (GPU.tier) {
      case 3: {
        return GPU.isMobile ? 300 : 450;
      }
      case 2: {
        return GPU.isMobile ? 200 : 300;
      }
      case 1: {
        return GPU.isMobile ? 150 : 256;
      }
      default: {
        return GPU.isMobile ? 100 : 128;
      }
    }
  }, [GPU]);

  const { scale } = useSpring({
    to: { scale: [2, 2, 2] },
    from: { scale: [0, 0, 0] },
  });

  useEffect(() => {
    ref.current.geometry.computeTangents();
  }, []);

  // [설정/블롭] 1-4 페이지를 지나가는 동안 보여짐
  const theta = Math.random() * Math.PI * 2; // 위에서 봤을 때 떨어지는 각도
  const startOffset = 0.08; // 떨어지기 시작하는 시점
  const speed = 4.5; // 떨어지는 속도
  const amplitude = 10; // 떨어질 때 퍼지는 정도
  const minimumScale = 6.0; // 메인 스피어 최소 크기
  const shirinkingSpeed = 0.8; // 메인 스피어 스케일 줄어드는 속도

  useFrame(() => {
    const t = Math.max(Math.min(scroll.offset, 0.5) - startOffset, 0) * speed;
    ref.current.position.x =
      easeInBack(t) * Math.sin(theta + t * Math.PI) * amplitude;
    ref.current.position.y = t * t * -40; // -40 : 안정적으로 가려지는 위치
    ref.current.position.z =
      easeInBack(t) * Math.cos(theta + t * Math.PI) * amplitude;
    // // 떨어지면서 사이즈가 커짐

    ref.current.scale.x = Math.max(
      minimumScale,
      2 * easeInBack(Math.max(0, 1 - scroll.offset * shirinkingSpeed))
    );
    ref.current.scale.y = Math.max(
      minimumScale,
      2 * easeInBack(Math.max(0, 1 - scroll.offset * shirinkingSpeed))
    );
    ref.current.scale.z = Math.max(
      minimumScale,
      2 * easeInBack(Math.max(0, 1 - scroll.offset * shirinkingSpeed))
    );
  });

  return (
    <group>
      <animated.mesh ref={ref} scale={scale} position={[0, 0, 0]}>
        {/* <sphereGeometry args={[3, 32, 32]} /> */}
        <sphereGeometry args={[3, resolution, resolution]} />
        <ChaosMaterial />
      </animated.mesh>
    </group>
  );
};

export default Sphere;
